import axios from "./axios.js";

// 获取首页信息
export function getActivityInfo() {
  return axios.post("activity/elevengroup/getActivityInfo");
}

// 微信js配置参数
export function getWXJSConfig(data) {
  return axios.get("activity/elevengroup/getWXJSConfig", {
    params: data
  });
}

/* 
  获取团信息
  @data: {
    groupId,    // not necessary
  }
*/
export function getGroupInfo(data) {
  return axios.post("activity/elevengroup/getGroupInfo", data);
}

// 开团
export function openGroup(data) {
  return axios.post("activity/elevengroup/openGroup", data);
}

// 参与拼团
export function helpGroup(data) {
  return axios.post("activity/elevengroup/helpGroup", data);
}

// 领取1元优惠券
export function receiveOne(data) {
  return axios.post("activity/elevengroup/receiveOne", data);
}